import React from 'react';
import classNames from 'classnames';
import Divider from '../divider';
import Heading from '../heading';
import Paragraph from '../paragraph';
import { APPEARANCES } from './constants';
const HeadingGroup = ({
  title,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
  description = null,
  appearance = APPEARANCES.default,
  children = null,
}) => {
  const headingGroupClasses = classNames('ws-ui-heading-group', {
    'ws-ui-heading-group--with-description': description,
  });

  return (
    <div className={headingGroupClasses}>
      <div className="ws-ui-heading-group__title">
        <Heading type="heading-5" appearance={appearance}>
          {title}
        </Heading>
      </div>

      <div className="ws-ui-heading-group__divider">
        <Divider appearance={appearance} />
      </div>

      {(description || children) && (
        <div className="ws-ui-heading-group__content">
          {description && (
            <Paragraph size="small" appearance="medium-emphasis">
              {description}
            </Paragraph>
          )}

          {children}
        </div>
      )}
    </div>
  );
};

export default HeadingGroup;
